




import { Component, Mixins } from "vue-property-decorator";
import { Mixin } from "@/core/mixins/mixin";
import PerOrder from "@/views/TicketOrder/PerOrderDetails/PerOrder.vue";

@Component({
  components: {
    PerOrder,
  },
})
export default class ExternalAccessPreOrderPage extends Mixins(Mixin) {}
